import * as React from 'react';
import { cn } from '@/lib/utils';
import { useFieldControl } from './field';

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        'flex h-11 w-full min-w-0 rounded-lg border border-line-strong bg-transparent px-3 py-2 text-sm',
        'placeholder:text-ink-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...useFieldControl(props)}
    />
  ),
);
Input.displayName = 'Input';
